import { Pipe, PipeTransform } from '@angular/core';
import { TableColumn } from '../table.types';

@Pipe({
  name: 'appGetColumnValue',
  standalone: true,
})
export class GetColumnValuePipe implements PipeTransform {

  public transform(row: any, column: TableColumn): string {
    if (column?.value !== undefined) {
      if (typeof column.value === 'function') {
        return column.value(row);
      }

      return column.value;
    } else if (column?.name) {
      return row?.[column.name] ?? '';
    }

    return '';
  }

}
